import Vue from 'vue';
import Vuex from 'vuex';

// eslint-disable-next-line import/no-cycle
import Auth from './modules/Auth/Logged';
import Budget from './modules/Budget/Budget';
import General from './modules/General/OrganizationStatus';
import OrganizationServiceOrder from './modules/General/OrganizationServiceOrder';
import ServiceOrder from './modules/ServiceOrder/ServiceOrder';
import Payment from './modules/Payment/Payment';
import ClientClassification from './modules/ClientClassification/ClientClassification';
import ServiceOrderTask from './modules/ServiceOrderTask/ServiceOrderTask';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    Auth,
    Budget,
    General,
    Payment,
    ServiceOrder,
    ClientClassification,
    OrganizationServiceOrder,
    ServiceOrderTask
  }
});
